import React from 'react';
import AddEditClaimant from '@components/case-details-routes/AddEditClaimant';

export default function ClaimantDetail(props) {
  return <AddEditClaimant {...props} />;
}
